import { makeAutoObservable } from "mobx";
import { SearchObject, SearchDrug } from "app/common/Model/SearchObject";
import {
    deleteDrug,
    getAllDrug,
    getDrugById,
    pagingDrug,
    saveDrug,
    pagingDoseByDrugId,
    saveDrugSyncStore
} from 'app/services/DrugService';
import { Drug } from "app/common/Model/Drug";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { downloadRevenueTemplateStaff, importStaffRevenueExcel } from "app/services/ImportExcelService";
import moment from "moment";

/*
*   Sản phẩm/Thuốc
*/
export default class DrugStore {
    listAllDrug = [];
    searchDrug = new SearchDrug();
    pageDrug = null;
    selectedDrug = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteDrug = false;
    selectedRowDrug = null;
    openSyncStore = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllDrug = () => {
        if (this.listAllDrug?.length === 0) {
            getAllDrug()
                .then(({ data }) => this.listAllDrug = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingDrug = () => {
        let { patientTypeServiceIds, departmentApplyIds, ...ortherData } = this.searchDrug;
        if (Array.isArray(patientTypeServiceIds)) {
            ortherData.patientTypeServiceIds = patientTypeServiceIds.map(
                (item) => item?.id || item
            );
        }
        if (Array.isArray(departmentApplyIds)) {
            ortherData.departmentApplyIds = departmentApplyIds.map((item) => item?.id || item);
        }
        pagingDrug(ortherData)
            .then(({ data }) => {
                this.pageDrug = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    pagingDoseByDrugId = (drugId, searchObject) => {
        pagingDoseByDrugId(drugId, searchObject)
            .then(({ data }) => {
                this.pageDrug = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchDrug) => {
        const clone = { ...searchDrug };
        if (Array.isArray(clone.abstractProductIds)) {
            clone.abstractProductIds = clone.abstractProductIds.map(item => item?.id);
        }
        else if (clone.abstractProductIds && typeof clone.abstractProductIds === "object") {
            clone.abstractProductIds = [clone.abstractProductIds.id];
        }
        this.searchDrug = checkSearchObject(this.searchDrug, clone);
        this.pagingDrug();
    };

    handleOpenFormCreateOrEdit = (drugId) => {
        if (Boolean(drugId)) {
            getDrugById(drugId)
                .then(({ data }) => {
                    this.selectedDrug = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedDrug = new Drug();
            this.openFormCreateOrEdit = true;
        }
    }

    saveDrug = async (drug, { setSubmitting }) => {
        return await saveDrug(drug)
            .then(() => {
                this.selectedDrug = null;
                toast.success("Lưu sản phẩm thành công!");
                this.handleClosePopup();
                this.pagingDrug();
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin sản phẩm có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteDrug = (drug) => {
        this.selectedDrug = { id: drug?.id };
        this.openConfirmDeleteDrug = true;
    }

    handleConfirmDeleteDrug = () => deleteDrug(this?.selectedDrug?.id)
        .then(() => {
            if (this.searchDrug.pageIndex > 1 && this.pageDrug?.content?.length === 1) {
                this.searchDrug.pageIndex -= 1;
            }
            toast.success("Xóa sản phẩm thành công!")
            this.handleClosePopup();
            this.pagingDrug();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa sản phẩm có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteDrug = false;
    }

    handleOpenSyncStore = () => {
        this.openSyncStore = true
    }

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveDrugSyncStore(data).then(() => {
            this.openSyncStore = false;
            toast.success("Đồng bộ sản phẩm thành công")
            this.pagingDrug()
        }).catch((err) => {
            toast.error("Đồng bộ sản phẩm thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    setSelectedRowDrug = (row) => {
        this.selectedRowDrug = row;
    };

    resetStore = () => {
        this.searchDrug = new SearchObject();
        this.pageDrug = null;
        this.selectedDrug = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteDrug = false;
    }

    //for choosing drug popup in ChooseDrugPopup.jsx 
    listDrug = [];
    drugIdSet = null;

    convertToEhMedicalHistoryDto = drug => {
        const dto = {
            id: drug?.id || drug?.drugId,
            drugId: drug?.drugId || drug?.id,
            drugName: drug?.drugName || drug?.name,
            drugCode: drug?.drugCode || drug?.code,
            code: drug?.code || drug?.drugCode,
            name: drug?.name || drug?.drugName,
            price: drug?.price,
            drugUnit: drug?.drugUnit || drug?.unit?.name
        };
        return dto;
    }

    idValidDrug = drug => {
        if (drug && (drug?.id || drug?.drugId)) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addDrug = drug => {
        if (!this.idValidDrug(drug)) return;
        this.listDrug.push(this.convertToEhMedicalHistoryDto(drug));
        this.drugIdSet.add(drug?.id || drug?.drugId);
    }

    initializeListDrug = drugs => {
        this.drugIdSet = new Set();
        this.listDrug = [];
        if (drugs && drugs?.length > 0) {
            for (let i = 0; i < drugs.length; i++) {
                this.addDrug(drugs[i]);
            }
        }
    }

    removeDrug = drug => {
        if (!this.idValidDrug(drug)) return;
        if (this.drugIdSet.has(drug?.id)) {
            this.drugIdSet.delete(drug?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = drug => {
        if (!this.idValidDrug(drug)) return;
        return this.drugIdSet.has(drug?.id);
    }

    getDrugIdSet = () => {
        return this.drugIdSet;
    }

    getListDrug = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listDrug && this.listDrug?.length > 0) {
            for (let i = 0; i < this.listDrug.length; i++) {
                const drug = this.listDrug[i];
                if (this.isExist(drug) && !bufferIdSet.has(drug?.id)) {
                    data.push(drug);
                    bufferIdSet.add(drug?.id);
                }
            }
        }
        this.listDrug = data;
        return data;
    }

    handleImportStaffRevenueAllocation = (file) => {
        importStaffRevenueExcel(file)
            .then(({ data }) => {
                toast.success("Tải file thành công!");
                this.pagingDrug();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
    };

    handleDownloadTemplateRevenueTemplateStaff = async () => {
        try {
            const res = await downloadRevenueTemplateStaff();
            const url = window.URL.createObjectURL(res?.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                "MAU_PHAN_BO_DOANH_THU_NHAN_VIEN" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error);
        }
    };
    //end
}